import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;
class ClosingBalance {

  create = async (date: any) => {
    const res = await axios({
      method: "post",
      url: `${API_URL}closing-balance`,
      data: date,
    }).catch((e) => {
      const { message } = e.response.data;
      if (message.errorInfo) throw message.errorInfo[2];
      else throw e.message;
    });
    return res.data;
  };

  // edit = async (transaction: any, code: any) => {
  //   await axios({
  //     method: "put",
  //     url: `${API_URL}account-transaction/${code}`,
  //     data: transaction,
  //   }).catch((e) => {
  //     // const { message } = e.response.data;
  //     // if (message.errorInfo) throw message.errorInfo[2];
  //     // else throw e.message;
  //     throw e;
  //   });
  // };

  get = async (date: any) => {
    const response = await axios({
      method: "get",
      url: `${API_URL}general-ledger/${date}`,
    }).catch((e) => {
      throw e.message;
    });
    return response.data.transaction;
  };

  getAll = async () => {
    const response = await axios({
      method: "get",
      url: `${API_URL}account-transaction`,
    }).catch((e) => {
      throw e.message;
    });
    return response.data.accTransaction;
  };

  getAllTransactionType = async () => {
    const response = await axios({
      method: "get",
      url: `${API_URL}account-transaction-type`,
    }).catch((e) => {
      throw e.message;
    });
    return response.data.accTransactionType;
  };

  previewClosingBalance = async (values: any) => {
    const response = await axios({
      method: "get",
      url: `${API_URL}closing-balance-preview`,
      params: {
        date: values.date,
        fromDate: `${values.date} 00:00:00`,
        toDate: `${values.date} 23:59:59`,
        task: values.task
      },
    }).catch((e) => {
      throw e.message;
    });
    return response.data.generalLedger;
  };


  getClosingBalanceByDateAndType = async (values: any) => {
    const response = await axios({
      method: "get",
      url: `${API_URL}closing-balance-by-date-type`,
      params: {
        date: values.date,
        ledgerTypeCode: values.ledgerType.code
      },
    }).catch((e) => {
      throw e.message;
    });
    return response.data.closingBalance;
  };

  getClosingBalanceByDate = async (values: any) => {
    const response = await axios({
      method: "get",
      url: `${API_URL}closing-balance-by-date`,
      params: {
        date: values.date,
        ledgerTypeCode: values.ledgerType?.code
      },
    }).catch((e) => {
      throw e.message;
    });
    return response.data.closingBalance;
  };

  getClosingBalanceByUser = async (values: any,id:any) => {
    const response = await axios({
      method: "get",
      url: `${API_URL}closing-balance-preview-by-user`,
      params: {
        id:values.user.id,
        date: values.date,
        
      },
    }).catch((e) => {
      throw e.message;
    });
    return response.data.generalLedger;
  };



}


export default new ClosingBalance();
